(function () {
    const form = document.querySelector('[data-contact-form]');

    if (!form) {
        return;
    }

    const endpoint = form.dataset.endpoint;
    const status = form.querySelector('[data-contact-status]');
    const submitButton = form.querySelector('[data-contact-submit]');
    const submissionTypeInputs = form.querySelectorAll('input[name="submissionType"]');
    const applicationFields = form.querySelector('[data-contact-application-fields]');
    const captchaContainer = form.querySelector('[data-contact-turnstile]');
    const defaultButtonText = submitButton ? submitButton.textContent : 'Send message';
    let widgetId = null;
    let renderAttemptCount = 0;

    function setStatus(message, tone) {
        if (!status) {
            return;
        }

        status.textContent = message || '';
        status.dataset.state = tone || '';
    }

    function setLoadingState(isLoading) {
        if (!submitButton) {
            return;
        }

        submitButton.disabled = isLoading;
        submitButton.textContent = isLoading ? 'Sending...' : defaultButtonText;
    }

    function syncApplicationFields() {
        if (!applicationFields) {
            return;
        }

        const selectedType = form.querySelector('input[name="submissionType"]:checked');
        const isApplication = selectedType && selectedType.value === 'content-writing';

        applicationFields.hidden = !isApplication;

        applicationFields.querySelectorAll('[data-required-when-application]').forEach((field) => {
            field.required = Boolean(isApplication);
        });
    }

    function renderTurnstile() {
        if (!captchaContainer || widgetId !== null || !window.turnstile) {
            return;
        }

        const siteKey = captchaContainer.dataset.sitekey;

        if (!siteKey) {
            return;
        }

        widgetId = window.turnstile.render(captchaContainer, {
            sitekey: siteKey,
            theme: 'light'
        });
    }

    function ensureTurnstileReady() {
        renderAttemptCount += 1;

        if (window.turnstile) {
            renderTurnstile();
            return;
        }

        if (renderAttemptCount > 40) {
            return;
        }

        window.setTimeout(ensureTurnstileReady, 150);
    }

    async function handleSubmit(event) {
        event.preventDefault();

        if (!endpoint) {
            setStatus('The contact form endpoint is not configured yet.', 'error');
            return;
        }

        const turnstileToken = widgetId !== null && window.turnstile
            ? window.turnstile.getResponse(widgetId)
            : '';

        if (!turnstileToken) {
            setStatus('Complete the captcha before sending.', 'error');
            return;
        }

        setLoadingState(true);
        setStatus('', '');

        try {
            const payload = {
                submissionType: form.querySelector('input[name="submissionType"]:checked')?.value || 'inquiry',
                fullName: form.elements.fullName.value.trim(),
                email: form.elements.email.value.trim(),
                subject: form.elements.subject.value.trim(),
                message: form.elements.message.value.trim(),
                portfolioUrl: form.elements.portfolioUrl ? form.elements.portfolioUrl.value.trim() : '',
                topics: form.elements.topics ? form.elements.topics.value.trim() : '',
                website: form.elements.website ? form.elements.website.value.trim() : '',
                turnstileToken
            };

            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json().catch(() => ({}));

            if (!response.ok) {
                throw new Error(result.error || 'Something went wrong while sending your message.');
            }

            form.reset();
            syncApplicationFields();
            if (widgetId !== null && window.turnstile) {
                window.turnstile.reset(widgetId);
            }
            setStatus(result.message || 'Thanks. Your message has been sent.', 'success');
        } catch (error) {
            setStatus(error.message || 'Something went wrong while sending your message.', 'error');
            if (widgetId !== null && window.turnstile) {
                window.turnstile.reset(widgetId);
            }
        } finally {
            setLoadingState(false);
        }
    }

    submissionTypeInputs.forEach((input) => {
        input.addEventListener('change', syncApplicationFields);
    });

    syncApplicationFields();
    ensureTurnstileReady();
    form.addEventListener('submit', handleSubmit);
})();
